import React from 'react'
import { useIntl } from 'react-intl'
import withAuth from '../../../components/withAuth'
import InnerPage from '../../../components/layout/InnerPage'
import Heading from '../../../components/Heading'
import { LayoutRow } from '../../../components/layout'
import LoanSettingsForm from './forms/LoanSettingsForm'
import LoanPage from '../../../components/LoanPage'

const LoanDetails = () => {
	const { formatMessage } = useIntl()

	const pageTitle = formatMessage({
		id: 'loan_settings.heading',
	})
	return (
		<LoanPage
			page="app-loan-settings"
			title={pageTitle}
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.settings' }),
					value: 'settings',
				},
			]}
		>
			<InnerPage>
				<LayoutRow>
					<Heading>{pageTitle}</Heading>
				</LayoutRow>
				<LayoutRow>
					<LoanSettingsForm />
				</LayoutRow>
			</InnerPage>
		</LoanPage>
	)
}

export default withAuth(LoanDetails)
